import React from 'react';
import PropTypes from 'prop-types';
import DebounceTextField from '../../atoms/DebounceTextField';

const TextSearchFilter = ({
  value,
  label,
  placeholder,
  onChange,
  style,
  inputProps,
  delay = 500,
}) => {
  return (
    <div style={{display: 'flex', alignItems: 'center', ...style}}>
      {label && <span style={{marginRight: '15px'}}>{label} </span>}
      <DebounceTextField
        style={{minWidth: '350px'}}
        placeholder={placeholder}
        onChange={onChange}
        delay={delay}
        value={value}
        {...inputProps}
      />
    </div>
  );
};

TextSearchFilter.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  delay: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  inputProps: PropTypes.object,
};

export default TextSearchFilter;
